var _defs, _path, _path2, _path3, _circle, _circle2, _polygon, _polygon2, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartUpWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.66 70.46",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.61,38.49v9.99h-6.97v-13.71c0-.16-.02-.32-.02-.49l6.99,4.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.8,34.77v13.71h-6.97v-9.99l6.99-4.2c0,.16-.02.32-.02.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.76,48.48v-13.71c0-11.49,3.67-22.42,10.45-31.44,6.78,9.03,10.45,19.96,10.45,31.44v13.71h-20.91Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 34.22,
    cy: 24.09,
    r: 3.48
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 34.22,
    cy: 38.02,
    r: 3.48
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.11 58.17 61.7 64.32 59.08 70.46 73.66 64.36 59.11 58.17"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: ".8 60.06 9.32 60.06 8.52 68.58 0 68.58 .8 60.06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.05,49.8c0,8.03-6.5,14.52-14.52,14.52H4.66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.76,49.8c0,8.03,6.5,14.52,14.52,14.52h14.09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartUpWhite);
export default __webpack_public_path__ + "static/media/start-up-white.e55c134d7a0d75b3c5e67c4b10dd4404.svg";
export { ForwardRef as ReactComponent };